import { type OrgClientRead } from '@libraries/typescript/api_client/schema_types';

export type ClientNotificationTarget = {
    readonly secondaryContactName: string | null;
};

type ClientSecondaryContact = NonNullable<
    OrgClientRead['secondary_contacts']
>[number];

type ClientNotificationPhoneFields = Pick<
    OrgClientRead,
    'phone_number' | 'mobile_phone_number' | 'home_phone_number'
> & {
    readonly secondary_contacts?: Array<
        Pick<
            ClientSecondaryContact,
            | 'name'
            | 'mobile_phone_number'
            | 'home_phone_number'
            | 'is_preferred_for_client_notifications'
        >
    > | null;
};

export function resolveClientNotificationTarget(
    client: ClientNotificationPhoneFields | undefined,
): ClientNotificationTarget | null {
    if (!client) {
        return null;
    }

    const secondaryContact = client.secondary_contacts?.find(
        (contact) =>
            contact.is_preferred_for_client_notifications === true &&
            contact.name.trim().length > 0 &&
            Boolean(contact.mobile_phone_number || contact.home_phone_number),
    );
    if (secondaryContact) {
        return { secondaryContactName: secondaryContact.name };
    }

    const hasPhoneNumber = Boolean(
        client.phone_number ||
        client.mobile_phone_number ||
        client.home_phone_number,
    );
    return hasPhoneNumber ? { secondaryContactName: null } : null;
}
